
import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import tableCheck from "@/mixins/table-check";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { emptyToLine } from "@/utils/common";
import dayjs from "dayjs";
import { Pageniation, Loading } from "@/utils/decorator";
import t from "@common/src/i18n/t";
import { MessageBox, Message } from 'element-ui';
const userMember = namespace("userMember");
const base = namespace("base");
const consult = namespace("consult");

@Component({
  components: { TableEnableFlag }
})
@Pageniation("loadListData")
export default class AppVersion extends Mixins(tableCheck) {
  @base.Action getDictionaryList;
  @userMember.Action getUserMemberList;
  dayjs = dayjs;
  visible: boolean = true;
  searchForm = {
    applicationCode: ""
  };
  emptyToLine = emptyToLine;
  userMemberList: any[] = [];
  storeTypeList: any[] = [];
  publisherList: any = [];
  get searchList() {
    return [
      {
        label: "客户姓名",
        type: "input",
        value: "",
        prop: "nickName"
      },
      {
        label: "联系电话",
        type: "input",
        value: "",
        prop: "phone"
      },
      {
        label: "等级",
        type: "select",
        selectList: [
          {
            label: "大众会员",
            value: "1"
          },
          {
            label: "黄金",
            value: "2"
          },
          {
            label: "铂金",
            value: "3"
          },
          {
            label: "钻石",
            value: "4"
          }
        ],
        value: "",
        prop: "level"
      }
    ];
  }
  //多行文本省略
  filters(value) {
    if (!value) return "";
    if (value.length > 20) {
      return value.slice(0, 20) + "...";
    }
    return value;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    console.log(this.searchForm, "searchfrom");

    this.loadListData();
  }
  created() {
    this.init();
  }

  async init() {
    this.loadListData();
  }

  @Loading()
  loadListData() {
    return this.getUserMemberList({
      ...this.searchForm,
      current: this.mix_pageNum,
      size: this.mix_pageSize
    }).then(data => {
      this.userMemberList = data.data.list;
      return data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/app/app-version-edit/${row.id}`);
  }

  handleDelete(row) {
    MessageBox.confirm("此操作将永久删除该条目, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      // this.deleteVersion({
      //   id: row.id
      // }).then(() => {
      //   this.$message.success("删除成功");
      //   this.$router.push("/app/app-version-list");
      // });
    });
  }
}
